import { AuthResponse } from '../apiResponseTypes';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';

export const TRY_REFRESH_AUTH_TOKEN = 'TRY_REFRESH_AUTH_TOKEN';
export const TRY_SILENT_REFRESH_TOKEN = 'TRY_SILENT_REFRESH_TOKEN';

export const CLEAR_AUTH = 'CLEAR_AUTH';

export const TWO_FACTOR_AUTH_REQUIRED = 'TWO_FACTOR_AUTH_REQUIRED';
export const REDIRECT_AUTH_NEEDED = 'REDIRECT_AUTH_NEEDED';

export interface AuthRedirectPayload {
    authRedirectUrl: string;
}

export interface FetchStateRequest {
    orgId?: string;
    userId: string;
    stapeId?: string;
    hubspotUserToken: string;
}

// Requests

export interface AuthSuccessAction {
    type: typeof AUTH_SUCCESS;
    payload: AuthResponse;
}

export interface TryRefreshAuthTokenAction {
    type: typeof TRY_REFRESH_AUTH_TOKEN;
    payload: {
        accessToken?: string;
    };
}

export interface TrySilentRefreshTokenAction {
    type: typeof TRY_SILENT_REFRESH_TOKEN;
}

export interface ClearAuthAction {
    type: typeof CLEAR_AUTH;
}

export interface TwoFactorAuthRequiredAction {
    type: typeof TWO_FACTOR_AUTH_REQUIRED;
    userId: string;
}

export interface RedirectAuthNeededAction {
    type: typeof REDIRECT_AUTH_NEEDED;
    payload: AuthRedirectPayload;
}

// Action Creators

export const authSuccess: (payload: AuthResponse) => AuthSuccessAction = (payload) => {
    return {
        type: AUTH_SUCCESS,
        payload,
    };
};

export const updateTwoFactorAuthRequired: (userId: string) => TwoFactorAuthRequiredAction = (userId: string) => {
    return {
        type: TWO_FACTOR_AUTH_REQUIRED,
        userId: userId,
    };
};

export const redirectAuthNeeded: (payload: AuthRedirectPayload) => RedirectAuthNeededAction = (payload) => {
    console.debug('[REDIRECT DEBUG]', 'redirectAuthNeeded', payload);
    return {
        type: REDIRECT_AUTH_NEEDED,
        payload,
    };
};

export const tryRefreshAuthToken: (accessToken?: string) => TryRefreshAuthTokenAction = (accessToken) => {
    return {
        type: TRY_REFRESH_AUTH_TOKEN,
        payload: {
            accessToken,
        },
    };
};

export const trySilentRefreshToken: () => TrySilentRefreshTokenAction = () => {
    return {
        type: TRY_SILENT_REFRESH_TOKEN,
    };
};

export const clearAuth: () => ClearAuthAction = () => {
    return {
        type: CLEAR_AUTH,
    };
};
